import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showModal } from '/shared/state/actions/modal';

import { getReductionPlanVersionSelector } from '/business/shared/state/selectors/application/basket_meta/getBasketMetaSelector';
import getHasDismissedReductionMigrationModalSelector from '/business/shared/state/selectors/applicationFlags/getHasDismissedReductionMigrationModalSelector';
import type { AppDispatch, RootState } from '/business/shared/state/store';

function ReductionMigrationModalTrigger() {
  const dispatch = useDispatch<AppDispatch>();
  const stateReductionPlanVersion = useSelector(getReductionPlanVersionSelector);
  const hasDismissed = useSelector(getHasDismissedReductionMigrationModalSelector) || false;
  const currentModal = useSelector((state: RootState) => state.modal?.modal) || null;

  const isMigratedFromOldVersion = stateReductionPlanVersion !== null && stateReductionPlanVersion !== 3;
  const shouldShow = isMigratedFromOldVersion && !hasDismissed && currentModal === null;

  // Shows at most once per mount: when the modal closes, this effect re-runs before the
  // dismissal flag from the modal's unmount has reached this component's render snapshot
  const hasTriggeredRef = useRef(false);

  useEffect(() => {
    if (shouldShow && !hasTriggeredRef.current) {
      hasTriggeredRef.current = true;
      dispatch(showModal({ name: 'REDUCTION_MIGRATION' }));
    }
  }, [shouldShow, dispatch]);

  return null;
}

export default ReductionMigrationModalTrigger;
